import { render, staticRenderFns } from "./Sozjob.vue?vue&type=template&id=6e227362&scoped=true"
import script from "./Sozjob.vue?vue&type=script&lang=js"
export * from "./Sozjob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e227362",
  null
  
)

export default component.exports